import { useQuery } from 'react-query';
import { SurveyRequest } from '../../../entities/v1/reference_check/SurveyRequest';
import {
  ShowParams,
  SurveyRequestService,
} from '../../../services/v1/referenceCheck/SurveyRequestService';

export const useSurveyRequest = (params: ShowParams) =>
  useQuery<SurveyRequest>(
    ['survey-requests', params.id, params.applicationExternalId],
    async () => {
      if (!params.id && !params.applicationExternalId) return null;

      return await SurveyRequestService.show(params);
    },
  );
